import { db } from '@/lib/firebase';
import { doc, getDoc } from 'firebase/firestore';

// Testimonial Interface for customer-facing app
export interface CustomerTestimonial {
  id: string;
  customerName: string;
  customerLocation?: string;
  rating: number;
  content: string;
  productId?: string;
  isVerified: boolean;
  avatar?: string;
  bgColor?: string;
  createdAt?: Date;
}

export interface TestimonialConfig {
  testimonials: CustomerTestimonial[];
  lastUpdated?: Date;
}

/**
 * Get published testimonials from Firestore
 */
export const getPublishedTestimonials = async (): Promise<CustomerTestimonial[]> => {
  try {
    const testimonialRef = doc(db, 'config', 'testimonials');
    const testimonialDoc = await getDoc(testimonialRef);
    
    if (!testimonialDoc.exists()) {
      return [];
    }
    
    const data = testimonialDoc.data();
    const testimonials = data.testimonials || [];
    
    // Filter only published testimonials and map to customer interface
    const publishedTestimonials = testimonials
      .filter((testimonial: any) => testimonial.status === 'published')
      .map((testimonial: any) => {
        const customerTestimonial: CustomerTestimonial = {
          id: testimonial.id,
          customerName: testimonial.customerName,
          rating: testimonial.rating,
          content: testimonial.content,
          isVerified: testimonial.isVerified ?? true,
          avatar: testimonial.avatar,
          bgColor: testimonial.bgColor || 'from-blue-500 to-indigo-600',
          createdAt: testimonial.createdAt?.toDate ? testimonial.createdAt.toDate() : new Date()
        };

        // Only include customerLocation if it exists and has actual content (not empty string)
        if (testimonial.customerLocation && testimonial.customerLocation.trim() !== '') {
          customerTestimonial.customerLocation = testimonial.customerLocation;
        }

        // Only include productId if it exists and has actual content (not empty string)
        if (testimonial.productId && testimonial.productId.trim() !== '') {
          customerTestimonial.productId = testimonial.productId;
        }

        return customerTestimonial;
      });
    
    return publishedTestimonials;
  } catch (error) {
    console.error('Error fetching published testimonials:', error);
    return [];
  }
}; 